import React from 'react';
import { AppUserDashboard } from '../components/dashboard/AppUserDashboard';

export const Dashboard: React.FC = () => {

  return <AppUserDashboard />;
};
